module.exports = __webpack_public_path__ + "media/ZhaoLei-LiXiang.bd2cc352.mp3";